import { render, staticRenderFns } from "./TwoFactor.vue?vue&type=template&id=bb79878c&scoped=true&"
import script from "./TwoFactor.vue?vue&type=script&lang=ts&"
export * from "./TwoFactor.vue?vue&type=script&lang=ts&"
import style0 from "./TwoFactor.vue?vue&type=style&index=0&id=bb79878c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb79878c",
  null
  
)

export default component.exports